export default "__VITE_ASSET__C8EDYXaA__"